import { Container, Panel, Sidenav, Content, Dropdown, Breadcrumb, IconButton, Avatar } from "rsuite"
import GearCircleIcon from '@rsuite/icons/legacy/GearCircle';
import NoticeIcon from '@rsuite/icons/Notice';

import { forwardRef } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";

export default function Header({pageName}) {
    const { panel, key } = useParams();

    const cookies = new Cookies();
    const navigator = useNavigate();
    
    const renderToggle = props => (
        <Avatar className="page-avatar" {...props} size="md" circle src="/build/avatar.png" />
      );

    return (
        <Dropdown placement="bottomEnd" renderToggle={renderToggle}>
            <Dropdown.Item panel>
                <div style={{padding: "0.5rem 1rem"}}>
                    {localStorage.getItem("username")}
                </div>
            </Dropdown.Item>
            <Dropdown.Separator />
            <Dropdown.Item onClick={() => 
                {
                    localStorage.clear();
                    cookies.remove('token', { path: '/' });
                    navigator("/login");
                }
            }>Выйти</Dropdown.Item>
        </Dropdown>
    )
}